import { HStack, Text, Spinner } from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import DeleteAccountModal from '../../modals/DeleteAccountModal';
import { useState, useEffect } from 'react';

const DeleteAccount = ({
  isOpen,
  onClose,
  text,
  selectedAccount,
  setIsDeleting: setParentIsDeleting,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    // Update parent component's state if the prop is provided
    if (setParentIsDeleting) {
      setParentIsDeleting(isDeleting);
    }
  }, [isDeleting, setParentIsDeleting]);

  const handleClose = () => {
    if (!isDeleting) {
      onClose();
    }
  };

  return (
    <>
      <HStack>
        {isDeleting ? (
          <Spinner size="sm" color="error" />
        ) : (
          <DeleteIcon color="error" />
        )}
        {text && <Text>{text}</Text>}
      </HStack>
      <DeleteAccountModal
        isOpen={isOpen}
        onClose={handleClose}
        selectedAccount={selectedAccount}
        setParentIsDeleting={setIsDeleting}
      />
    </>
  );
};

export default DeleteAccount;
